<template>
  <div class="g-pages">
    <div class="box">
      <span class="text text1" style="color: #333;">共{{ total }}条,每页 <a-input type="number" class="total" v-model="pageSizeValue"></a-input>条</span>
      <div class="con2">
        <a-pagination v-model="pageValue" :default-current="page" :default-pageSize="pageSize" :pageSize.sync="pageSizeValue" :total="total"  @change="onChange" />
        <div class="boxr">
          到第<a-input type="text" name="" id="" class="inp" v-model="pageValue"></a-input>
          <span class="text text2">页</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {debounce} from "throttle-debounce";

export default {
  name: 'mPages',
  props: ['page','total','pageSize'],
  data() {
    return {
      pageValue: 1,
      pageSizeValue: 20,
      // pageSizeChangeCall:
    }
  },
  watch:{
    page(v){
      this.pageValue = v
    },
    pageValue(v){
      this.$emit('update:page', parseInt(v))
    },
    pageSize:{
      immediate: true,
      handler(v) {
        this.pageSizeValue = v
      }
    },
    pageSizeValue(v){
      this.pageSizeChangeCall(v)
    }
  },
  mounted() {
    this.pageSizeChangeCall = debounce(1000, (v)=>{
      console.log('pageSize: ', v);
      this.$emit('update:pageSize', parseInt(v))
    })
  },
  methods: {
    // 页码
    onChange(pageNumber) {
      console.log('Page: ', pageNumber);
      this.$emit('update:page', pageNumber)
    },
  }
}
</script>

<style lang="scss" scoped>
// 页码
.g-pages {
  overflow: hidden;
  padding-bottom: 36px;
  margin: 34px 0 0;
}

.g-pages .total {
  width: 100px;
  height: 50px;
  font-size: 14px;
  border: 1px solid #EBF1F5;
  text-align: center;
  margin: 0 10px;
}

.g-pages .con2 {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.g-pages .boxr {
  font-size: 14px;
  color: #333333;
  margin-left: 50px;
}

.g-pages .boxr .inp {
  width: 50px;
  height: 50px;
  line-height: 48px;
  font-size: 14px;
  border: 1px solid #EBF1F5;
  margin: 0 10px;
  font-size: 14px;
  color: #333333;
  border-radius: 3px;
}

.g-pages .box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.g-pages .ant-pagination {
  display: inline-block;
  vertical-align: middle;
  padding: 0 0px 0 30px;
}

.g-pages .text {
  display: inline-block;
  vertical-align: middle;
  font-size: 13px;
  color: #707070;
}

.g-pages .text2 {
  // width: 142px;

}

.ant-pagination-options {
  margin-left: 50px;
}

.g-pages .ant-pagination-prev .ant-pagination-item-link,
.g-pages .ant-pagination-next .ant-pagination-item-link {
  border: none;
  background-color: transparent;
}

.g-pages .ant-pagination-prev {
  max-width: 10px;
  height: 28px;
  line-height: 29px;
}

.g-pages .ant-pagination-next {
  max-width: 28px;
  height: 28px;
  line-height: 29px;
  margin-right: 10px;
}

.g-pages .ant-pagination-item:focus,
.ant-pagination-item:hover {
  border-color: transparent;
}

.g-pages .ant-pagination-item {
  background: #F9F9F9;
  border-radius: 4px;
  max-width: 40px;
  height: 40px;
  line-height: 38px;
  border: none;
  margin-right: 5px;
}

.g-pages .ant-pagination-item:hover,
.g-pages .ant-pagination-item-active {
  background: #0E63CD;
}

.g-pages .ant-pagination-options-quick-jumper,
.g-pages .ant-pagination-item a {
  font-size: 14px;
  font-family: Arial;
  color: #707070;
}

.g-pages .ant-pagination-item:hover a,
.g-pages .ant-pagination-item-active a {
  color: #FEFEFE;
}

.g-pages .ant-pagination-item a {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.g-pages .ant-pagination-options-quick-jumper input {
  width: 40px;
  height: 28px;
  background: #F6F7F8;
  border-radius: 5px;
  padding: 0 5px;
  border: none;
}
</style>
